import { isAllowedAccountNameCharsOnly, MAX_EXPENSE_ACCOUNT_CODE_LENGTH, textNoWhiteSpacesRegex } from "@finway-group/shared/lib/utils/validators"
import { FormInstance, Rule } from "antd/lib/form"

import i18n from "Shared/locales/i18n"
import { FormService } from "Shared/services"
import { insertIf, isUniqueInReduxAndForm } from "Shared/utils/helper.utils"

import { stringRules } from "Components/forms/rules/common/string.rules"
import { generalRules } from "Components/forms/rules/common/general.rules"

export const createExpenseAccountRules = (formInstance: FormInstance, isEdit: boolean, allowSpecialCharCodes: boolean) => ({
    accountCode: [
        generalRules.required,
        stringRules.noExcessWhitespace,
        {
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }

                if (!textNoWhiteSpacesRegex.test(value)) {
                    return Promise.reject(new Error(i18n.t("validation:string_white_space")))
                }
                const { formValues, existingValuesRaw } = FormService.getFormAndReduxValues("expenseAccounts", formInstance)
                if (!isUniqueInReduxAndForm({ formValues, existingValuesRaw, valueKey: "accountCode", value, isEdit })) {
                    return Promise.reject(i18n.t("validation:unique", { value: i18n.t("validation:account_code") }))
                }

                if (value.length > MAX_EXPENSE_ACCOUNT_CODE_LENGTH) {
                    return Promise.reject(i18n.t("validation:max.string", { max: MAX_EXPENSE_ACCOUNT_CODE_LENGTH }))
                }

                return Promise.resolve()
            },
        },
        ...insertIf(!allowSpecialCharCodes, stringRules.allowedMultiLineCharsOnly),
    ] as Array<Rule>,
    accountName: [
        generalRules.required,
        stringRules.noExcessWhitespace,
        {
            validator: (_rule, value: string) => {
                if (!isAllowedAccountNameCharsOnly(value)) {
                    return Promise.reject(new Error(i18n.t("validation:invalid_characters")))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
